<template>
    <hh-accent-panel class="property-notes">
        <div class="grid cols-3_1 --mobile">
            <h3>{{ title }}</h3>
            <div class="property-notes__actions --end">
                <hh-btn :text="buttonTextActual" track-operation-state @click="$emit('click')" />
            </div>
        </div>
        <slot :notes="notes" />
        <ul>
            <li v-for="note in notes" :key="note.key">
                <strong>{{ note.label }}</strong>
                <div v-if="note.info">
                    {{ note.info }}
                </div>
            </li>
        </ul>
    </hh-accent-panel>
</template>

<script>

import ResourcesHelper from '@/components/resources-helper'
import { DEFAULT_NOTES } from '@/schemes/scheme-config'

export default {
    mixins: [ ResourcesHelper ],

    props: {
        title: {
            type: String,
            required: true,
        },
        project: {
            type: Object,
            required: true,
        },
        buttonText: {
            type: String,
            default: '',
        },
    },

    computed: {
        /**
         * @returns {string}
         */
        buttonTextActual() {
            return this.buttonText || this.commonResources.change
        },

        /**
         * @returns {Array<{key: string, label: string, info: ?string}>}
         */
        notes() {
            const map = {}
            const getAdditionalInfo = key => {
                // special case for repair details
                if (key === DEFAULT_NOTES.repairsNeeded)
                    key = DEFAULT_NOTES.repairDetails

                return map[key].value !== 'Y' ? map[key].value : null
            }

            this.project.notes.filter(({ value }) => value !== 'N').forEach(note => map[note.key] = note)

            return this.$scheme.notes.filter(note => note.key in map).map(({ key, label }) => ({
                key,
                label,
                info: getAdditionalInfo(key),
            }))
        },
    },
}

</script>

<style lang="scss">

.property-notes {
    h3 {
        margin-bottom: 0.2rem;
    }
}

</style>
